import { ServiceProviderType } from "@/types";
import * as React from "react";
import { AIGAccountFields } from "./AIGAccountFields";
import { BankingAccountFields } from "./BankingAccountFields";
import { CreditCardsAccountFields } from "./CreditCardsAccountFields";
import { DefaultAccountFields } from "./DefaultAccountFields";
import { EnergyAccountFields } from "./EnergyAccountFields";
import { HastingsDirectAccountFields } from "./HastingsDirectAccountFields";
import { InsuranceAccountFields } from "./InsuranceAccountFields";
import { QuilterAccountFields } from "./Investments/QuilterInvestment";
import { InvestmentsAccountFields } from "./InvestmentsAccountFields";
import { MobileAccountFields } from "./MobileAccountFields";
import { MortgageAccountFields } from "./MortgageAccountFields";
import { PensionAccountFields } from "./PensionAccountFields";
import { Record as ServiceProviderRecord } from "./ServiceProviderFields";
import { SocialMediaOrEmailAccountFields } from "./SocialMediaOrEmailAccountFields";
import { AccountFieldProps } from "./types/AccountFieldProps";
import { WaterAccountFields } from "./WaterAccountFields";

// Function to get the appropriate account fields component
export function getAccountFieldsComponent(sp: ServiceProviderRecord) {
  if (!sp?.serviceProviderId && !sp.addingServiceProvider) return NoAccountFields;

  // First, check if a custom form component exists
  const customFormComponent = accountFieldsByCustomForm(sp);
  if (customFormComponent) return customFormComponent;

  // Fallback to component based on service provider type
  return accountFieldsByServiceProviderType(sp);
}
// Function to get account fields component based on custom form
function accountFieldsByCustomForm(sp: ServiceProviderRecord) {
  switch (sp.customForm) {
    case "aig":
      return AIGAccountFields;
    case "hastings-direct":
      return HastingsDirectAccountFields;
    case "quilter":
      return QuilterAccountFields;
    default:
      return null;
  }
}
// Function to get account fields component based on service provider type
function accountFieldsByServiceProviderType(sp: ServiceProviderRecord) {
  switch (sp.serviceProviderType) {
    case ServiceProviderType.Banking:
    case ServiceProviderType.BuildingSociety:
      return BankingAccountFields;
    case ServiceProviderType.CreditCards:
      return CreditCardsAccountFields;
    case ServiceProviderType.Energy:
      return EnergyAccountFields;
    case ServiceProviderType.Insurance:
      return InsuranceAccountFields;
    case ServiceProviderType.Investments:
      return InvestmentsAccountFields;
    case ServiceProviderType.Mobile:
      return MobileAccountFields;
    case ServiceProviderType.Mortgage:
      return MortgageAccountFields;
    case ServiceProviderType.Pension:
      return PensionAccountFields;
    case ServiceProviderType.SocialMedia:
    case ServiceProviderType.Email:
      return SocialMediaOrEmailAccountFields;
    case ServiceProviderType.Water:
      return WaterAccountFields;
    case undefined:
    case null:
      return NoAccountFields;
    default:
      return DefaultAccountFields;
  }
}
// Component to render when there are no account fields
const NoAccountFields: React.FC<AccountFieldProps> = ({ updateTemplate }) => {
  // Use effect to update the template if applicable
  React.useEffect(() => {
    if (updateTemplate) {
      updateTemplate({});
    }
  }, [updateTemplate]);

  return null;
};
